module.exports = __webpack_public_path__ + "src/components/Menu/assets/net-2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/assets/net-2.svg
// module id = 2920
// module chunks = 14